/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/updateProfile.config.json";
import notification from "../config/notifications.config.json";

import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_MY_PROFILE } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateProfileMethods extends IPluginMethodMap {
  getUpdateProfile(args: any): Promise<any>;
}

export interface UpdateProfileProps {
  name: string;
  description: string;
  email: string;
  phoneNumber: string;
  address: string;
  website: string;
}

export class UpdateProfileService implements IAgentPlugin {
  readonly methods: IUpdateProfileMethods;

  constructor() {
    this.methods = {
      getUpdateProfile: this.getUpdateProfile.bind(this),
    };
  }

  async getUpdateProfile(args: UpdateProfileProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_MY_PROFILE,
          variables: {
            input: {
              ...args,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.updateMyProfile) {
          return {
            data: res?.data?.updateMyProfile,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
